import { gql } from '@apollo/client';

export const DELETE_COST_CENTER = gql`
    mutation DeleteCostCenter($id: String!) {
        deleteCostCenter(id: $id) {
            name
        }
    }
`;
